import {FC, ReactNode} from "react";
import {OldBusinessInformation} from "./OldBusinessInformation";

import "./OldDetailsColumn.scss";
import {OldCommonOrgDealerStatusBar} from "./OldCommonOrgDealerStatusBar";
import {useOldCommonOrgEntity} from "../../context";
import {Address} from "../../overview/Address";
import {Oems} from "../../overview/Oems";
import {TabColumn} from "../../../tab-content";

interface OldDetailsColumnProps {
  detailsColumnHeader: ReactNode;
}
export const OldDetailsColumn: FC<OldDetailsColumnProps> = ({
  detailsColumnHeader
}) => {
  const {
    entity: {id, dealerInformation, oems}
  } = useOldCommonOrgEntity();

  return (
    <TabColumn name={"details-column"} header={detailsColumnHeader}>
      <OldCommonOrgDealerStatusBar />
      <OldBusinessInformation />
      <Address id={id} dealerInformation={dealerInformation} />
      <Oems id={id} oems={oems} />
    </TabColumn>
  );
};
